import {
  NBA_LOADING, SET_NBA_QUEUE, DISMISS_NBA,
} from '../actions/nba';

const INITIAL_STATE = { loading: true, details: [] };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case NBA_LOADING:
      return { ...state, loading: true };
    case SET_NBA_QUEUE:
      return {
        ...state, loading: false, details: action.payload,
      };
    case DISMISS_NBA:
      return {
        ...state,
        details: state.details.filter(nba => nba.id !== action.payload),
      };
    default:
      return state;
  }
}
